import Vue from 'vue';
import App from './App.vue';

import store from './store'
import router from './router'
import logJs from './js/log.js'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import { functionJs } from '@/utils/function.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.prototype.$video = Video
Vue.prototype.logJs = logJs
Vue.prototype.functionJs = functionJs

Vue.config.productionTip = false;

new Vue({
	render: h => h(App),
	router: router,
	store: store
}).$mount('#app');
